/* ============================================================
   Vantor — catalog labels + shop state + quote()  (app-250 catalog, app-240 money)
   SoT for the catalog shape: SiYuan Applications/vantor/catalog-truth-final.

   app-240: NO money lives in this file. TPC-1056: snippets/vantor-offer.liquid
   derives each variant's offer from Shopify (its state, and its full-pay and
   presale terms) and boot stamps that record into window.Vantor.shopRaw, in cents.
   This file turns it into dollars once and reads it: it never decides a stock
   state or works out an amount. Change the deposit, the discount or a price in
   Shopify Admin and every figure on the storefront follows.

   Loaded synchronously in <head>, after vantor-boot.

   QA override: ?cap=N / ?tent=N stands in for the inventory quantity of
   every variant of that product, for this page view only: N > 0 sells it on its
   full-pay terms, otherwise on its presale terms when it has valid ones (TPC-1175: the
   Tent has none, so ?tent=0 is sold out). A Builder add-on
   is keyed by its product handle: ?<handle>=N. It is
   never persisted: add-to-cart is real, and a remembered flag that disagrees with
   Shopify is a wrong charge.

   It is honoured ONLY when boot stamped shopRaw.qa === true, which it does only off
   the live theme (theme.role != 'main'). Shopify backstops the override in one
   direction only: asking for a plan the variant is not on is refused (422), but
   OMITTING selling_plan is always accepted, so on the live storefront ?cap=1 would
   sell an inventory-0 unit at full price with no deposit, no discount and no
   pre-order terms. Absent or any other value ⇒ the override is ignored.
   ============================================================ */
(function (root) {
  var CATALOG = {
    cap: {
      name: 'Cap', full: 'Vantor Aluminum Bed Cap',
      // lengths are the bed-length bands the Cap page and the builder print.
      lengths: [
        { id: '5',   value: '5 ft',   label: '5 ft',   fits: '5 ft beds · Tacoma, Frontier, Gladiator' },
        { id: '5.5', value: '5.5 ft', label: '5.5 ft', fits: 'beds from 5.5 ft to under 6 ft · Tundra, F-150, Silverado, Sierra, RAM 1500' },
        { id: '6',   value: '6 ft+',  label: '6 ft+',  fits: 'beds 6 ft and longer · every supported truck except Gladiator' }
      ],
      // TPC-1053: value is the Shopify option value of the Window option, matched exactly. label is what the
      // storefront prints. Renaming an option value in Shopify is not supported.
      windows: [
        { id: 'hardshell', value: 'Hardshell', label: 'Hardshell', code: 'H' },
        { id: 'sliding',   value: 'Sliding',   label: 'Sliding',   code: 'S' }
      ]
    },
    tent:    { name: 'Rooftop Tent' },
    // TPC-1141: installed in the Cap, as the Cap's Storage option. It is never its own cart line.
    storage: { name: 'Topper Storage Box' },

    // app-250: builder trucks — the full support list, in display order.
    //
    // PLATE-SHARE RULE (app-238): families are per truck. Every supported truck now owns
    // its own family of real plates — no truck borrows another's.
    // The `shared` flag marks a truck that is shown on a plate of a different truck, so the
    // viewport can caption it honestly. Nothing uses it today — every truck is shared: false.
    // Add a truck without its own plates by pointing it at an owner's family and setting the
    // flag; clear it back to shared: false the round that truck's own 4 plates ship.
    //
    // beds[].length is the bed's Cap length band (5 | 5.5 | 6), printed beside the bed.
    // Band rule (Jerry, 2026-09-20): a bed under 5.5 ft takes the 5 ft Cap · a bed from 5.5 ft
    // up to (not including) 6 ft takes the 5.5 ft Cap · 6 ft and longer takes 6 ft+. No 8 ft beds.
    trucks: [
      // BEGIN GENERATED vantor-fitments:catalog — from scripts/vantor-fitments.json; regenerate with node scripts/generate-vantor-fitments.mjs, do not edit by hand
      { id: 'tacoma',    make: 'Toyota',    model: 'Tacoma',    family: 'BLD-TAC', shared: false,
        beds: [{ id: '5', label: '5 ft', length: '5' }, { id: '6', label: '6 ft', length: '6' }] },
      { id: 'tundra',    make: 'Toyota',    model: 'Tundra',    family: 'BLD-TUN', shared: false,
        beds: [{ id: '5.5', label: '5.5 ft', length: '5.5' }, { id: '6.5', label: '6.5 ft', length: '6' }] },
      { id: 'f-series',  make: 'Ford',      model: 'F-150',     family: 'BLD-F15', shared: false,
        beds: [{ id: '5.5', label: '5.5 ft', length: '5.5' }, { id: '6.5', label: '6.5 ft', length: '6' }] },
      { id: 'silverado', make: 'Chevrolet', model: 'Silverado', family: 'BLD-SIL', shared: false,
        beds: [{ id: '5.8', label: '5.8 ft', length: '5.5' }, { id: '6.6', label: '6.6 ft', length: '6' }] },
      { id: 'sierra',    make: 'GMC',       model: 'Sierra',    family: 'BLD-SIE', shared: false,
        beds: [{ id: '5.8', label: '5.8 ft', length: '5.5' }, { id: '6.6', label: '6.6 ft', length: '6' }] },
      { id: 'ram-1500',  make: 'RAM',       model: '1500',      family: 'BLD-RAM', shared: false,
        beds: [{ id: '5.7', label: '5.7 ft', length: '5.5' }, { id: '6.4', label: '6.4 ft', length: '6' }] },
      { id: 'frontier',  make: 'Nissan',    model: 'Frontier',  family: 'BLD-FRO', shared: false,
        beds: [{ id: '5', label: '5 ft', length: '5' }, { id: '6', label: '6 ft', length: '6' }] },
      { id: 'gladiator', make: 'Jeep',      model: 'Gladiator', family: 'BLD-GLA', shared: false,
        beds: [{ id: '5', label: '5 ft', length: '5' }] }
      // END GENERATED vantor-fitments:catalog
    ]
  };

  /* ---------- shop data: cents → dollars, once ---------- */
  var V = root.Vantor = root.Vantor || {};
  var raw = V.shopRaw || null;
  function dollars(c) { return c / 100; }
  function terms(t, state) {
    if (!t.valid) return { state: 'out', valid: false, diagnostic: t.diagnostic, list: dollars(t.listCents), total: null, due: null, rem: null, savings: null, planId: null };
    return { state: state, valid: true, diagnostic: null, list: dollars(t.listCents), total: dollars(t.totalCents), due: dollars(t.dueCents),
      rem: dollars(t.remainderCents), savings: dollars(t.savingsCents), planId: t.effectivePlanId };
  }
  function fromCents(r) {
    return {
      id: r.id, kind: r.kind, qty: r.inventoryQuantity, tracked: r.inventoryTracked !== false,
      offer: terms(r, r.state), fullPay: terms(r.fullPay, 'in'), allocation: terms(r.allocation, 'pre')
    };
  }
  /* TPC-1054: boot stamps purchasing false, and no product record, while a core product mapping is not usable. */
  var purchasing = !raw || raw.purchasing !== false;
  var shop = { leadTime: raw ? raw.leadTime : '', variantsById: {}, unmatched: [] };
  /* TPC-1036: the in-stock window setting; an empty or missing one keeps the product-page wording. */
  shop.shipWindow = (raw && typeof raw.shipWindow === 'string' && raw.shipWindow.trim()) || '5–7 days';

  /* ---------- TPC-1141: one Cap is Fitment × Window × Storage, bought by Shopify ID ----------
     shopRaw.products is { cap, tent }: { id, url, options: [name], variants: [record + options: [value]] }.
     A Cap is the one variant whose Fitment, Window and Storage values match a selection. The three option
     names are found by exact name, in any order. Fitment is '<make> <model> | <bed label>' (fitmentOf),
     Window a catalog window value, Storage exactly 'Yes' or 'No'. A configuration two variants claim, or a
     Cap without exactly one option of each name, has no variant: there is no band, first-variant or SKU
     fallback. The Tent is its only variant. A core variant no selection reaches stays in variantsById and
     is listed in shop.unmatched; it is never bought in another's place. Option names and values are matched
     as Shopify stores them: a storefront translation of them would leave the Cap unchosen. */
  var picks = { cap: Object.create(null), tent: null };
  var STORAGE = { Yes: true, No: false };
  function optionAt(names, name) {
    var at = names.indexOf(name);
    return at !== -1 && names.indexOf(name, at + 1) === -1 ? at : -1;
  }
  function capKey(fitment, win, storage) { return fitment + '|' + win + '|' + storage; }
  function indexCap(p, variants) {
    var fi = optionAt(p.options, 'Fitment'), wi = optionAt(p.options, 'Window'), si = optionAt(p.options, 'Storage');
    if (fi === -1 || wi === -1 || si === -1) return;
    p.variants.forEach(function (rv, n) {
      var fitment = rv.options[fi], storage = rv.options[si];
      var w = CATALOG.cap.windows.find(function (x) { return x.value === rv.options[wi]; });
      if (typeof fitment !== 'string' || !fitment || !w || !Object.prototype.hasOwnProperty.call(STORAGE, storage)) return;
      var key = capKey(fitment, w.id, STORAGE[storage]);
      if (key in picks.cap) { picks.cap[key] = null; return; }
      variants[n].config = { fitment: fitment, window: w.id, storage: STORAGE[storage] };
      picks.cap[key] = variants[n];
    });
  }
  if (raw && raw.products) ['cap', 'tent'].forEach(function (kind) {
    var p = raw.products[kind];
    if (!p) return;
    var variants = p.variants.map(fromCents);
    variants.forEach(function (v) { shop.variantsById[String(v.id)] = v; });
    if (kind === 'cap') indexCap(p, variants);
    else picks[kind] = variants.length === 1 ? variants[0] : null;
    var reached = kind === 'cap' ? Object.keys(picks.cap).map(function (k) { return picks.cap[k]; }) : [picks[kind]];
    variants.forEach(function (v) { if (reached.indexOf(v) === -1) shop.unmatched.push(String(v.id)); });
  });
  /* The Fitment value of a supported truck and one of its actual beds, or null. */
  function fitmentOf(truckId, bedId) {
    var t = CATALOG.trucks.find(function (x) { return x.id === truckId; });
    var b = t && t.beds.find(function (x) { return x.id === bedId; });
    return b ? t.make + ' ' + t.model + ' | ' + b.label : null;
  }
  /* variantFor('cap', { fitment, window, storage }) with a window id and storage a boolean, variantFor('tent')
     → a variant, or null. A selection missing any of the three, or of another shape, is null. */
  function variantFor(kind, sel) {
    if (kind === 'tent') return picks.tent;
    if (kind !== 'cap' || !sel || typeof sel.fitment !== 'string' || typeof sel.storage !== 'boolean') return null;
    return picks.cap[capKey(sel.fitment, sel.window, sel.storage)] || null;
  }
  var state = { cart: raw ? (raw.cart || 0) : 0 };

  var query = new URLSearchParams(location.search);
  // the single gate every ?cap= / ?tent= read goes through (see the header)
  var qa = !!(raw && raw.qa === true);
  function override(kind) { return qa && query.has(kind); }

  function offerOf(v) {
    if (!v) return null;
    if (!override(v.kind)) return v.offer;
    return Math.max(0, parseInt(query.get(v.kind), 10) || 0) > 0 ? v.fullPay : v.allocation;
  }
  /* 'in' = in stock, pay in full · 'pre' = on its selling plan · 'out' = not purchasable. */
  function stateOf(v) {
    var o = offerOf(v);
    return o ? o.state : 'out';
  }
  /* Three states, three values: "1" shows the .when-<kind>-1 copy, "0" the presale copy,
     "out" the sold-out copy. Folding 'out' into "0" advertised the deposit above "Sold out". */
  function setFlag(kind, st) {
    document.documentElement.setAttribute('data-inv-' + kind, st === 'in' ? '1' : st === 'out' ? 'out' : '0');
  }

  /* app-238: the plate id. Storage is accepted and ignored on purpose — the Topper Storage
     Box never changes the image (Jerry 2026-09-23); the trailing digit is fixed 0.
     TPC-168: no Builder add-on reaches this function, so none can change the image. */
  function plateId(truck, win, tentOn, storageOn) { return truck.family + '-' + win.code + (tentOn ? 1 : 0) + '0'; }

  /* ---------- Builder add-ons (TPC-168) ----------
     shopRaw.addons is one entry per product whose Builder add-on field is on:
     { kind, title, variants: [the record boot prints for a core variant, without options] }. The builder page stamps it from
     snippets/vantor-builder-content.liquid, in <body>, after this file has run. So it is read on
     first use, and no other page has one. */
  var addonList = null, addonPage = 1;   // addonPage: the last page of the list that is in addonList
  function absorb(entries) {
    (entries || []).forEach(function (a) {
      if (a.variants.length) addonList.push({ kind: a.kind, title: a.title, variants: a.variants.map(fromCents) });
    });
  }
  function addonEntries() {
    if (!addonList && raw && raw.addons) { addonList = []; absorb(raw.addons); }
    return addonList || [];
  }
  /* An add-on sells its first variant that is not sold out. When all are, its first stands for it. */
  function addonVariant(a) {
    return a.variants.find(function (v) { return stateOf(v) !== 'out'; }) || a.variants[0];
  }
  /* What the builder paints a row from: [{ kind, title, price, state }], in the collection's order. */
  function addons() {
    return addonEntries().map(function (a) {
      var v = addonVariant(a);
      return { kind: a.kind, title: a.title, price: offerOf(v).list, state: stateOf(v) };
    });
  }
  /* Liquid gives the collection 250 products at a time. The page stamps the first 250 and their page
     count; this asks sections/vantor-builder-addons.liquid for each page after that, in order, and
     calls done once. A page that fails ends the walk, so the list never skips a page. A later call
     takes up at that page, and so does the next page view. With one page, which is any store of 250
     products or fewer, it asks nothing. */
  function loadAddons(done) {
    addonEntries();
    var pages = addonList ? raw.addonPages : 1;
    function next() {
      if (addonPage >= pages) return done();
      fetch(location.pathname + '?section_id=vantor-builder-addons&page=' + (addonPage + 1))
        .then(function (res) { return res.text(); })
        // the endpoint wraps the section in a <div>; the list is the JSON object inside it.
        // An error page holds no such list, so it fails here whatever its status.
        .then(function (html) {
          var list = JSON.parse(html.slice(html.indexOf('{'), html.lastIndexOf('}') + 1)).addons;
          if (!Array.isArray(list)) throw new Error('add-on page holds no list');
          absorb(list);
          addonPage++;
        })
        .then(next, function () { done(); });
    }
    next();
  }

  /* ---------- The general product page's product (TPC-164) ----------
     shopRaw.product is { title, variants: [the record boot prints for a core variant, without options] }. The page stamps it from
     snippets/vantor-pdp-general.liquid, in <body>, after this file has run. So it is read on first
     use, and no other page has one. */
  var pageProduct = null;
  function product() {
    if (!pageProduct && raw && raw.product) pageProduct = { title: raw.product.title, variants: raw.product.variants.map(fromCents) };
    return pageProduct;
  }
  /* A form control hands the id over as text. */
  function productVariant(id) {
    var p = product();
    return p ? p.variants.find(function (v) { return String(v.id) === String(id); }) : undefined;
  }

  /**
   * quote(sel) → what the ATC summary, the sticky footer and the cart request use.
   *
   * sel = { cap: {fitment, window, storage} | null, tent: bool, addons?: [kind], item?: {id, note} }
   *       cap is { fitment, window, storage }, the selection variantFor resolves; installed storage is part of that one Cap item.
   *       item is the general product page: the chosen variant's id, and the note under its line.
   * returns { lines, total, dueToday, remainder, presale, depositOnly, items }   when purchasable
   *         { blocked: 'Cap sold out' | 'Unavailable' }                          when not
   *
   * Every figure is Shopify's, as vantor-offer.liquid stamps it: list price, plan price, checkout charge, remaining balance.
   *   - 'in'  line: paid in full today. No selling_plan on the cart item, even if one is still attached.
   *   - 'pre' line: plan price, checkout charge today, remaining balance at ship. Terms apply PER line,
   *                 so Cap + Tent both at 0 stack two deposits and two discounts (Jerry lock 2026-09-19).
   *   - An add-on is a line like any other, under its product title.
   * items are ordered last add-on to first, Tent, Cap: Shopify lists the newest line first, so
   * the cart reads Cap first.
   */
  var PAY_AT_SHIP = 'Nothing today. Billed when it ships.';
  function payAtShip(v) { var o = offerOf(v); return !!o && o.state === 'pre' && o.due === 0; }
  function quote(sel) {
    if (!raw) return { blocked: 'Unavailable' };
    var lines = [], items = [], total = 0, due = 0, rem = 0, pre = 0, count = 0, blocked = null;

    function add(v, label, note, preNote) {
      var o = offerOf(v);
      if (!o) { blocked = blocked || 'Unavailable'; return; }
      if (o.state === 'out') { blocked = blocked || label + ' sold out'; return; }
      count++;
      var item = { id: v.id, quantity: 1 };
      if (o.state === 'pre') { pre++; note = preNote || note; }
      lines.push({ label: label, note: note, amount: o.list });
      if (o.savings > 0) lines.push({ label: 'Presale savings', note: label, amount: -o.savings, save: true });
      total += o.total; due += o.due; rem += o.rem;
      if (o.planId != null) item.selling_plan = o.planId;
      items.unshift(item);
    }

    if (sel.cap) {
      var cv = variantFor('cap', sel.cap);
      if (!cv) return { blocked: 'Unavailable' };
      var w = CATALOG.cap.windows.find(function (x) { return x.id === cv.config.window; });
      add(cv, 'Cap', cv.config.fitment + ' · ' + w.label + (cv.config.storage ? ' · Storage installed' : ''), null);
    }
    if (sel.tent) add(variantFor('tent'), CATALOG.tent.name, '');
    (sel.addons || []).forEach(function (kind) {
      var a = addonEntries().find(function (x) { return x.kind === kind; });
      var v = a && addonVariant(a);
      add(v, a && a.title, '', payAtShip(v) ? PAY_AT_SHIP : '');
    });
    if (sel.item) {
      var chosen = productVariant(sel.item.id);
      add(chosen, chosen && product().title, sel.item.note, payAtShip(chosen) ? PAY_AT_SHIP : null);
    }
    if (blocked) return { blocked: blocked };

    // depositOnly: a pure preorder with money due today — the button says "deposit". A mixed cart, or a
    // back-order with nothing due, does not.
    return { lines: lines, total: total, dueToday: due, remainder: rem, presale: pre > 0,
             depositOnly: pre > 0 && pre === count && due > 0, items: items };
  }

  /* The installed-storage control of one fitment and window: price is what storage adds to the Cap's list
     price, in dollars, and state the storage configuration's stock state. Each is null when a configuration
     it needs does not exist, so the control never prints an amount or a Sold out no variant has. */
  function capStorage(sel) {
    var off = variantFor('cap', { fitment: sel.fitment, window: sel.window, storage: false });
    var on = variantFor('cap', { fitment: sel.fitment, window: sel.window, storage: true });
    return { price: on && off ? offerOf(on).list - offerOf(off).list : null, state: on ? stateOf(on) : null };
  }

  /* The status line under the pills. Amounts come from the plan, the estimate from the theme setting. */
  function noteFor(v, noun) {
    var o = offerOf(v), st = o ? o.state : 'out';
    if (st === 'in') return 'In stock. Pay in full today. Ships in ' + shop.shipWindow + '.';
    if (st === 'out') return 'Sold out.';
    if (o.due === 0) return 'Out of stock. Nothing today, ' + money(o.rem) + ' billed when it ships, estimated ' + shop.leadTime + '.';
    return 'Preorder with a ' + money(o.due) + ' deposit' + (o.savings > 0 ? ' and take ' + money(o.savings) + ' off' : '') +
      '. The remainder is charged when your ' + noun + ' ships, estimated ' + shop.leadTime + '.';
  }

  /* Match Liquid money_without_trailing_zeros: whole dollars have no .00 (use cents to avoid float churn). */
  function money(n) {
    n = Number(n);
    if (!isFinite(n)) n = 0;
    var neg = n < 0;
    var cents = Math.round(Math.abs(n) * 100);
    var whole = cents % 100 === 0;
    var a = cents / 100;
    var s = '$' + a.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    return neg ? '−' + s : s;
  }

  /* Single writer for the header cart badge (app-256). Count = Shopify cart.item_count.
     Empty = no numeral (CSS also hides via [data-cart="0"]). */
  function setCartCount(n) {
    n = Math.max(0, parseInt(n, 10) || 0);
    state.cart = n;
    if (raw) raw.cart = n;
    document.documentElement.setAttribute('data-cart', n > 0 ? '1' : '0');
    document.querySelectorAll('[data-cart-link]').forEach(function (a) {
      a.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart, empty');
      var c = a.querySelector('[data-cart-count]');
      if (!c) return;
      c.textContent = n > 0 ? (n > 9 ? '9+' : String(n)) : '';
      if (n > 0) c.removeAttribute('aria-hidden');
      else c.setAttribute('aria-hidden', 'true');
    });
  }

  Object.assign(V, { CATALOG: CATALOG, shop: shop, state: state, setFlag: setFlag,
    variantFor: variantFor, fitmentOf: fitmentOf, plateId: plateId, quote: quote, capStorage: capStorage,
    addons: addons, loadAddons: loadAddons, offerOf: offerOf, stateOf: stateOf, noteFor: noteFor, productVariant: productVariant,
    money: money, setCartCount: setCartCount, purchasing: purchasing });
})(window);
